export default function HoverButton({
  BtnTitleClasses,
  onClick,
  BtnTitle,
  disabled,
  extraClasses,
  type,
}) {
  return (
    <button
      onClick={onClick}
      disabled={disabled}
      type={type}
      className={`gradient-container_btn ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${extraClasses}`}
    >
      <p className={`${BtnTitleClasses}`}>{BtnTitle}</p>
    </button>
  );
}
